export default "__VITE_ASSET__BEZvwJkV__"